// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BoldOutlinedSvg from "@fishx/icons-svg/es/asn/BoldOutlined";
import FishxIcon from '../components/FishxIcon';

var BoldOutlined = function BoldOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BoldOutlinedSvg
  }));
};

BoldOutlined.displayName = 'BoldOutlined';
export default React.forwardRef(BoldOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BoldOutlined.js
// module id = 2077
// module chunks = 0